import { appRouterPaths } from 'services/navigation';
import { TeacherWorkloadPage } from 'pages/TeacherWorkload';
import type { AppRouteProps } from '../types';

export const teacherWorkloadPageRoute: AppRouteProps = {
  path: appRouterPaths.teacherWorkload,
  element: <TeacherWorkloadPage />,
};
